import {
  BoundaryTerritoryType, type CalculateBucketFunctionNumeric,
} from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroup.type';
import type { BoundaryBucketType } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.repository';
import type { BoundaryTerritoryGroupStyle } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export type ColumnCoordinates = {
  readonly spreadsheetId: number;
  readonly columnId: string;
};

type BoundaryCommonConfig = {
  readonly boundaryFillId: Uuid;
  readonly style: BoundaryTerritoryGroupStyle;
};

export type BoundaryFillGroupConfig = BoundaryCommonConfig & {
  readonly boundaryTerritoryType: BoundaryTerritoryType.Groups;
  readonly boundaryFillData: ColumnCoordinates;
};

export type BoundaryFillDensityConfig = BoundaryCommonConfig & {
  readonly boundaryTerritoryType: BoundaryTerritoryType.Density;
  readonly rangesCount: number;
  readonly bucketType: BoundaryBucketType;
};

export type BoundaryFillNumericConfig = BoundaryCommonConfig & {
  readonly boundaryFillData: ColumnCoordinates;
  readonly boundaryTerritoryType: BoundaryTerritoryType.Numeric;
  readonly numericCalculateBucketFunction: CalculateBucketFunctionNumeric;
  readonly rangesCount: number;
  readonly bucketType: BoundaryBucketType;
};

export type BoundaryFillDemographicConfig = BoundaryCommonConfig & {
  readonly boundaryTerritoryType: BoundaryTerritoryType.Demographic;
  readonly rangesCount: number;
  readonly selectedDemographicId: string;
  readonly bucketType: BoundaryBucketType;
};

export type BoundaryFillManualConfig = BoundaryCommonConfig & {
  readonly boundaryTerritoryType: BoundaryTerritoryType.Manual;
};

export type BoundaryFillConfig =
  BoundaryFillGroupConfig
  | BoundaryFillDensityConfig
  | BoundaryFillNumericConfig
  | BoundaryFillDemographicConfig
  | BoundaryFillManualConfig;

export const isBoundaryFillGroupConfig = (
  config: BoundaryFillConfig,
): config is BoundaryFillGroupConfig => config.boundaryTerritoryType === BoundaryTerritoryType.Groups;

export const isBoundaryFillDensityConfig = (
  config: BoundaryFillConfig,
): config is BoundaryFillDensityConfig => config.boundaryTerritoryType === BoundaryTerritoryType.Density;

export const isBoundaryFillManualConfig = (
  config: BoundaryFillConfig,
): config is BoundaryFillManualConfig => config.boundaryTerritoryType === BoundaryTerritoryType.Manual;

export const isBoundaryFillNumericConfig = (
  config: BoundaryFillConfig,
): config is BoundaryFillNumericConfig => config.boundaryTerritoryType === BoundaryTerritoryType.Numeric;

export const isBoundaryFillDemographicConfig = (
  config: BoundaryFillConfig,
): config is BoundaryFillDemographicConfig => config.boundaryTerritoryType === BoundaryTerritoryType.Demographic;
